import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { TransactionSearchForm } from '../Forms';
import { Text1,Text4 } from '../../../styles';
import { Descriptions, Badge,Alert,Icon,Card } from "antd";
import { SMART_COLLECT_TRANSACTIONS_STATUS_TYPES } from "../../../constants";
import moment from 'moment';
import { alertify, handleApiExceptions, printRupee } from "../../../app_methods";
import { SmartCollectTransaction } from '../../../models';


const TransactionSearchModal = (props) => {
    const [isSearching, setIsSearching] = React.useState(false);
    const [activeTransaction, setActiveTransaction] = React.useState({});

    const SearchTransaction = async (data = {}) => {
        setIsSearching(true);
        data.amount= parseFloat(data.amount)
        const response = await SmartCollectTransaction.SearchTransaction(data)
        if (!response.success) {
            setIsSearching(false);
            handleApiExceptions(response);
            return;
        }
        setActiveTransaction(response.data);
        setIsSearching(false);
        if (!response.data.transactionFound){
            alertify("Oops!!!", response.data.message, "error");
        }
    }

    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                Transaction Lookup
            </Text1>
        )
    };

    const onCancel = () => {
        setActiveTransaction({});
        props.toggleTransactionSearchModal()
    }

    return (
        <EaseModal
            width={400}
            title={false}
            visible={props.visible}
            onCancel={onCancel}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <TransactionSearchForm
                loading={isSearching}
                onSubmit={SearchTransaction}
                merchant_id={props.merchantId}
            />
            {   activeTransaction.transaction ?
                <div>
                <Alert
                    className="mb-2 mt-2"
                    type="info"
                    message={activeTransaction.message}
                    icon={<Icon type="info-circle" />}
                    showIcon
                />
                <Card
                    className="mb-2"
                    size="small"
                    title={false}
                >
                    <div>
                        <div className='mb-2 d-flex justify-content-between'>
                            <div>
                                {(activeTransaction.transaction.status && (
                                <Badge
                                color={SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[activeTransaction.transaction.status].color}
                                text={<Text4>{SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[activeTransaction.transaction.status].label}</Text4>}
                                />
                                )) || "---"}
                            </div>
                            <div className="d-flex align-items-center justify-content-end">
                                <Text4 type="secondary">{(activeTransaction.transaction.transaction_date && moment(activeTransaction.transaction.transaction_date).format("LLL")) || "---"}</Text4>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <Text4 type="secondary" strong>Sender Name:</Text4>
                        </div>
                        <div className="mb-2 d-flex justify-content-between">
                            <Text4>{activeTransaction.transaction.remitter_full_name || "---"}</Text4>
                        </div>

                        <div className='d-flex justify-content-between'>
                            <Text4 type="secondary" strong>UPI Handle:</Text4>
                        </div>
                        <div className="mb-2 d-flex justify-content-between">
                            <Text4>{activeTransaction.transaction.remitter_upi_handle || "---"}</Text4>
                        </div>
                        <div className='d-flex align-items-center'>
                            <Text4 type="secondary" strong>Amount:</Text4>
                        </div>
                        <div className='mb-2 d-flex align-items-center'>
                            <Text4>{(activeTransaction.transaction.amount && printRupee(activeTransaction.transaction.amount)) || "---"}</Text4>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <Text4 type="secondary" strong>UTR:</Text4>
                        </div>
                        <div className='mb-2 d-flex align-items-center'>
                            <Text4>{activeTransaction.transaction.unique_transaction_reference || "---"}</Text4>
                        </div>
                    </div>
                </Card>
            </div>
            :null
            }
        </EaseModal>
    )
};

export { TransactionSearchModal };